import { Slider } from '@progress/kendo-react-inputs';
import React, { useEffect, useRef, useState } from 'react';

export default function ZoomInOut(props) {
  const { min, max, zoomVal, onZoomChange } = props;
  const [value, setValue] = useState(zoomVal);
  const debounceTimer = useRef(null);

  useEffect(() => {
    setValue(zoomVal);
  }, [zoomVal]);

  const onChange = (event) => {
    const newValue = Math.round(event.value);
    setValue(newValue);

    // Clear the previous debounce timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Set a new debounce timer
    debounceTimer.current = setTimeout(() => {
      onZoomChange(newValue);
    }, 300); // Adjust the delay as needed (e.g., 300ms)
  };


  return (
      <Slider min={min} max={max} step={1} value={value} onChange={onChange}>
      </Slider>
  );
}
